import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';
import * as _ from 'lodash';
import * as debug from 'debug';

@Directive({
  selector: '[appLongPress]',
})
export class LongPressDirective {
  log = debug('app:LongPressDirective');
  touchStartY = null;
  touchStartX = null;
  maxDelta = 15;

  constructor(public element: ElementRef) {
    // this.log('constructed', element);
  }
  @Output() longPress = new EventEmitter<void>();
  private timeout: any;
  private longPressDuration = 700; // Duration in milliseconds

  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  onMouseDown(event: MouseEvent | TouchEvent) {
    // in onEnter(), add:
    this.touchStartY = _.get(event, 'touches[0].screenY');
    this.touchStartX = _.get(event, 'touches[0].screenX');

    this.timeout = setTimeout(() => {
      this.longPress.emit();
    }, this.longPressDuration);
  }

  @HostListener('mouseup')
  @HostListener('mouseleave')
  @HostListener('touchend')
  onMouseUp() {
    clearTimeout(this.timeout);
    this.touchStartY = null;
    this.touchStartX = null;
  }

  @HostListener('touchmove')
  onMove(evt) {
    // console.log('onMove');
    const yPosition = _.get(evt, 'touches[0].screenY');
    const xPosition = _.get(evt, 'touches[0].screenX');

    // if (
    //   (!_.isUndefined(this.touchStartY) &&
    //     !_.isUndefined(this.touchStartX) &&
    //     Math.abs(yPosition - this.touchStartY) > this.maxDelta) ||
    //   Math.abs(xPosition - this.touchStartX) > this.maxDelta
    // ) {
    clearTimeout(this.timeout);
    // }
  }
}



// WEBPACK FOOTER //
// ./src/directives/long-press-directive/long-press-directive.ts